module.exports = __webpack_public_path__ + "static/media/BackgroundPay.b4ec13d1.svg";